import React, { useEffect, useState } from "react";
import {
  Grid,
  Box,
  Typography,
  IconButton,
  Button,
  Tooltip,
} from "@mui/material";
// import { ReactComponent as Oflag } from '../../StaticData/Svgs/Oflag.svg';
// import {ReactComponent as CompanyManagmentIcon} from '../../../../components/Dashboard/StaticsData/Icons/companyManagmentIcon1.svg';
// import {ReactComponent as PersonIcon} from '../../../../components/Dashboard/StaticsData/Icons/Person1.svg';
// import PersonIcon from "@mui/icons-material/Person";
import FlagIcon from "@mui/icons-material/Flag";
import CompanyManagmentIcon from "@mui/icons-material/DeveloperBoard";
import { ReactComponent as comp } from "../../StaticData/Svgs/Oflag.svg";
import TransferIcon from '@mui/icons-material/ChangeCircle';
import { useNavigate } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import {
  useDeleteObject,
  useLikeObjective,
  useDisLikeObjective,
  useTransferObjective,
} from "../../Hooks";
import DyLinearProgress from "../../../../components/GlobalComponents/DyLinearProgress/DyLinearProgress";
import { useSelector } from "react-redux";
import LikeIcon from "@mui/icons-material/Favorite";
import "../../../CompanyManagment/Copmonents/Like/Like.css";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
//Naderi 14030526
import { NewUseStore } from "../../../../Store/newUseStore";
import DYToastMessage from "../../../../components/GlobalComponents/DyToastMessage/DYToastMessage";
import CommentModal from "../../../TenantDash/LComponents/AllTenantDash/AnotherComponent ";
// import ModalLyt from "../../../../components/Layouts/ModalLyt/ModalLyt";
//

const OCart = (props: any) => {
  const navigate = useNavigate();
  let {
    obj,
    setObjectiveId,
    setShowEditForm,
    personPicture,
    setShowToastMessage1,
    setObjectiveAsyncOpState,
    setDeleteObjectiveState,
  } = props;
  let {
    name,
    responsibleName,
    responsibleId,
    definitionLevelName,
    setShowEditModal,
    id,
    weight,
    evaluationPercentage,
    objectivesStateName,
    keyResultCount,
    pictureBase64String,
    liked,
    likeCount,
    commentCount
  } = obj;
  const tenantId = useSelector((state: any) => state.meetings.profileTenantId);

  const {
    mutate: deleteObjectve,
    isError,
    isSuccess,
    data: deleteData,
  } = useDeleteObject();
  const { mutate: likeObjectve, data: likeData } = useLikeObjective();
  const { mutate: disLikeObjectve, data: disLikeData } = useDisLikeObjective();
  const [imgSrc, setImgSrc] = useState<any>(null);
  const [likec, setLikeCount] = useState<number>(likeCount);
  const [activeBtn, setActiveBtn] = useState<string>("none");
  const [isSucces, SetIsSuccess] = useState<boolean>();
  const [tMessage, SetTMessage] = useState<string>();
  const [showToastMessage, setShowToastMessage] = useState<boolean>(false);
  const [open, setOpen] = React.useState(false);
  const [open1, setOpen1] = React.useState(false);
  const{mutate:deleteMission,data:transferData}=useTransferObjective();
  const initialTransferShowDet=()=>{
    setOpen1(true);
  }
  //Naderi 14030526
  const updateObjectiveChanged = NewUseStore(
    (state) => state.updateObjectiveChanged
  );
  //

  const goObjectiveDetails = () => {
    navigate("/dashboard/okrManagment/objectiveDetails", {
      replace: true,
      state: { objectiveId: id },
    });
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  
  const handleClose1 = () => {
    setOpen1(false);
  };

  //Naderi 14030526
  const initialDeleteObject = () => {
    try {
      let deleteBody = {
        deletedId: id,
        tenantId: tenantId,
      };
      deleteObjectve(deleteBody);
      handleClose();
    } catch (error) {
      updateObjectiveChanged({
        show:true,
        state: false,
        message: "خطا در عملیات",
      });
    }
  };

  const initialDeleteObject1=()=>{
    let invitedPersonBody={
        id:id,
    }
    deleteMission(invitedPersonBody)
    handleClose1();
   }

   const initialDeleteObject2=()=>{
    let invitedPersonBody={
        id:id,
        withKR:true
    }
    deleteMission(invitedPersonBody)
    handleClose1();
   }

  //

  const initialLikeObject = () => {
    let deleteBody = {
      objectiveId: id,
      tenantId: tenantId,
    };
    likeObjectve(deleteBody);
  };

  const initialDisLikeObject = () => {
    let deleteBody = {
      objectiveId: id,
      tenantId: tenantId,
    };
    disLikeObjectve(deleteBody);
  };

  useEffect(() => {
   if (transferData) {
     if (transferData?.data.isSuccess) {
       // setSuccessAddObjective(isSuccess)
       setShowToastMessage(true);
       SetIsSuccess(true);
       SetTMessage(transferData?.data.metaData.message);
     } else {
       setShowToastMessage(true);
       SetIsSuccess(false);
       SetTMessage(transferData?.data.metaData.message);
     }
   }
  }, [transferData]);

  useEffect(() => {
    if (deleteData) {
      if (deleteData?.data.isSuccess) {
        // setSuccessAddObjective(isSuccess)
        setShowToastMessage(true);
        SetIsSuccess(true);
        SetTMessage(deleteData?.data.metaData.message);
      } else {
        setShowToastMessage(true);
        SetIsSuccess(false);
        SetTMessage(deleteData?.data.metaData.message);
        // setAddObjError(deleteData?.data);
      }
    }
  }, [deleteData]);

  useEffect(() => {
    if (obj) {
      setLikeCount(likeCount);
      if (liked) {
        setActiveBtn("like");
      }
    }
  }, likeCount);

  const initialEditObject = (perId: string | null) => {
    setShowEditForm(true);
    setObjectiveId(id);
  };

  useEffect(() => {
    if (obj) {
      setImgSrc(pictureBase64String);
    }
  }, [obj]);

  // const [dislikeCount, setdisLikeCount] = useState<number>(50);

  const handleReactionClick = (reaction: string): void => {
    if (activeBtn === "none") {
      // if (reaction === "dislike") {
      //   setdisLikeCount(dislikeCount + 1);
      //   setActiveBtn("disLike");
      // } else
      if (reaction === "like") {
        setLikeCount(likec + 1);
        setActiveBtn("like");
        initialLikeObject();
      }
    } else if (activeBtn === reaction) {
      // if (reaction === "dislike") {
      //   setdisLikeCount(dislikeCount - 1);
      // } else
      if (reaction === "like") {
        setLikeCount(likec - 1);
        initialDisLikeObject();
      }
      setActiveBtn("none");
    } else if (activeBtn !== reaction) {
      // if (reaction === "dislike") {
      //   setdisLikeCount(dislikeCount + 1);
      //   setLikeCount(likeCount - 1);
      //   setActiveBtn("dislike");
      // } else
      if (reaction === "like") {
        // setdisLikeCount(dislikeCount + 1);
        // setdisLikeCount(dislikeCount - 1);
        setActiveBtn("like");
      }
    }
  };
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));


  return (
//     <Grid container boxShadow={4} borderRadius={4} p={2}>
//       <Grid item xs={12}>
//         <Grid container>
//           <Grid item xs={12}>
//             <Box
//               display={"flex"}
//               width={"100%"}
//               alignItems={"start"}
//               minHeight={"80px"}
//               justifyContent={"space-between"}
//             >
//               <Box display={"flex"}>
//                 <FlagIcon fontSize="large" />
//                 {name.length > 65 ? (
//                   <Tooltip sx={{ fontSize: "1.5rem !important" }} title={name}>
//                     <Typography
//                       mt={1}
//                       textAlign={"left"}
//                       variant="body1"
//                       sx={{
//                         fontSize: "13px !important",
//                         fontWeight: "600",
//                         color: "black",
//                         cursor: "pointer",
//                       }}
//                     >
//                       {name.slice(0, 65)}
//                     </Typography>
//                   </Tooltip>
//                 ) : (
//                   <Typography
//                     mt={1}
//                     textAlign={"left"}
//                     sx={{
//                       fontSize: "13px !important",
//                       fontWeight: "600",
//                       color: "black",
//                       cursor: "pointer",
//                     }}
//                   >
//                     {name}
//                   </Typography>
//                 )}

//                 {/* 


//         <Typography px={1} variant='body1' fontWeight={900} >
//             {
//                 name
//             }
//         </Typography> */}
//               </Box>
//               <Box display={"flex"} justifyContent={"end"}>
//                 <Box>
//                   <Tooltip title="ویرایش">
//                     <IconButton
//                       onClick={() => {
//                         initialEditObject(id);
//                       }}
//                     >
//                       <EditIcon color="primary" />
//                     </IconButton>
//                   </Tooltip>
//                 </Box>
//                 <Box>
//                   <Tooltip title="حذف">
//                     <IconButton onClick={handleClickOpen}>
//                       <DeleteIcon color="error" />
//                     </IconButton>
//                   </Tooltip>
//                   <Dialog
//                     fullScreen={fullScreen}
//                     open={open}
//                     onClose={handleClose}
//                     aria-labelledby="responsive-dialog-title"
//                   >
//                     <DialogTitle
//                       id="responsive-dialog-title"
//                       fontWeight={600}
//                       fontSize={"17px"}
//                     >
//                       {"آیا از حذف هدف اطمینان دارید؟"}
//                     </DialogTitle>
//                     <DialogActions>
//                       <Button autoFocus onClick={handleClose}>
//                         <Typography color={"red"}> انصراف</Typography>
//                       </Button>
//                       <Button
//                         onClick={() => {
//                           initialDeleteObject();
//                         }}
//                         autoFocus
//                       >
//                         <Typography color={"#00387C"}> تایید</Typography>
//                       </Button>
//                     </DialogActions>
//                   </Dialog>
//                 </Box>
//               </Box>
//             </Box>
//             {/* <Box display={'flex'} justifyContent={'end'} >
//         <Box >
//         <div className="btnn-container">
//             <button 
//           className={`btnn ${activeBtn === "like" ? "like-active " : ""}`}
//           onClick={() => handleReactionClick("like")}
//         >
//           <LikeIcon />{likeCount}
//         </button>
//         </div>
//         </Box>
//         </Box> */}
//           </Grid>
//           {/* <Grid item xs={2}>
//         <Box >
       
//       </Box>
//       </Grid> */}
//         </Grid>

//         {/* <Grid item xs={2}   >
//         <Box width={'100%'} py={2} textAlign={'center'}>
//             <IconButton>
//             <MoreVertIcon/>
//             </IconButton>
//           </Box>
//          </Grid> */}
//       </Grid>

//       <Grid xs={12}>
//         <Box
//           width={"100%"}
//           marginLeft={1}
//           display={"flex"}
//           alignItems={"center"}
//           justifyContent={"start"}
//         >
//           {/* <PersonIcon width={"15px"} height={"15px"} /> */}
//           {/* <img src={imgSrc} width={'20px'}  height={'20px'}
//         style={{borderRadius:'50%',boxShadow:'20px'}}
//          /> */}
        //  <img src={
        //           personPicture !== null && personPicture !== undefined &&
        //           personPicture.filter((x:any)=>x.personId === responsibleId)[0] !== null &&
        //           personPicture.filter((x:any)=>x.personId === responsibleId)[0]!== undefined
        //           ?
        //           personPicture.filter((x:any)=>x.personId === responsibleId)[0].pictureBase64String
        //           :''
        //         } width={'25px'} style={{borderRadius:'50%'}} />
//           <Typography px={1} variant="button" fontWeight={900} color={"black"}>
//             {responsibleName}
//           </Typography>
//         </Box>
//       </Grid>

//       <Grid xs={12}>
//       <Box width="100%" display="flex" flexDirection="row-reverse" alignItems="center">
//               <Box display="flex" justifyContent="end" alignItems="center">
//                 <div className="btnn-container">
//                   <button
//                     className={`btnn ${activeBtn === "like" ? "like-active" : ""}`}
//                     onClick={() => handleReactionClick("like")}
//                   >
//                     <LikeIcon />
//                     {likec}
//                   </button>
//                 </div>
//               </Box>
//               <Box mr={2}>
//                 <CommentModal id={id} name={name} commentCount={commentCount}/>
//               </Box>
//           <Box
//             marginLeft={1}
//             width={"100%"}
//             display={"flex"}
//             alignItems={"center"}
//             justifyContent={"start"}
//           >
//             <CompanyManagmentIcon width={"20px"} height={"20px"} />
//             {/* <Typography px={1} variant='button' fontWeight={900} color={'black'} >
//                 {
//                     definitionLevelName
//                 }
//         </Typography> */}
//             {definitionLevelName.length > 45 ? (
//               <Tooltip
//                 sx={{ fontSize: "0.75rem !important" }}
//                 title={definitionLevelName}
//               >
//                 <Typography
//                   px={1}
//                   variant="button"
//                   sx={{ color: "black", fontWeight: "900", textAlign: "left" }}
//                 >
//                   {definitionLevelName.slice(0, 45)}
//                 </Typography>
//               </Tooltip>
//             ) : (
//               <Typography
//                 px={1}
//                 variant="button"
//                 sx={{ color: "black", fontWeight: "900", textAlign: "left" }}
//               >
//                 {definitionLevelName}
//               </Typography>
//             )}
//           </Box>
//         </Box>
//       </Grid>

//       <Grid item xs={12}>
//         <Box width={"100%"}>
//           <DyLinearProgress value={evaluationPercentage} />
//         </Box>
//       </Grid>

//       <Grid xs={12}>
//         <Box
//           display={"flex"}
//           alignItems={"center"}
//           justifyContent={"space-between"}
//           textAlign={"center"}
//         >
//           <Box
//             display={"flex"}
//             alignItems={"center"}
//             textAlign={"center"}
//             justifyContent={"center"}
//             bgcolor={objectivesStateName === "فعال" ? "#D5f7D4" : "#bfd3f5"}
//             width={"90px"}
//             height={"28px"}
//             borderRadius={3}
//           >
//             <Typography
//               color={objectivesStateName === "فعال" ? "green" : "#3a82fc"}
//               fontSize={"0.8rem"}
//             >
//               {" "}
//               {objectivesStateName === "فعال" ? "فعال" : "پیش نویس"}
//             </Typography>
//           </Box>
//           <Box
//             display={"flex"}
//             alignItems={"center"}
//             justifyContent={"space-between"}
//             textAlign={"center"}
//           >
//             <Box
//               display={"flex"}
//               alignItems={"center"}
//               textAlign={"center"}
//               justifyContent={"center"}
//             ></Box>
//           </Box>

//           <Box
//             display={"flex"}
//             alignItems={"center"}
//             textAlign={"center"}
//             justifyContent={"center"}
//             bgcolor={"#FBF0EA"}
//             width={"95px"}
//             height={"28px"}
//             borderRadius={3}
//           >
//             <Typography color={"#F95700"} fontSize={"0.8rem"}>
//               {keyResultCount} نتیجه کلیدی
//             </Typography>
//           </Box>

//           <Box
//             display={"flex"}
//             textAlign={"center"}
//             alignItems={"center"}
//             justifyContent={"end"}
//             marginLeft={1}
//             width={"100px"}
//             borderRadius={3}
//           >
//             <Button variant="text" onClick={goObjectiveDetails}>
//               <Typography fontSize={"0.8rem"} color={"#0d0d0c"}>
//                 نمایش جزئیات
//               </Typography>
//             </Button>

//             {/* <IconButton onClick={()=>{
//             //initialEditTeam()
//         }}   >
//         <EditIcon color='primary'   />
//        </IconButton> */}
//           </Box>

//           {/* <Box marginTop={'0.5'}>
      
//       </Box> */}

//           {/* 
// <IconButton onClick={()=>{
//             initialDeleteObject()
//         }}  >
//             <DeleteIcon color='error'/>
//         </IconButton> */}
//         </Box>
//       </Grid>
//       {showToastMessage && (
//           <DYToastMessage
//             isSuccess={isSucces}
//             message={tMessage}
//             setShow={setShowToastMessage}
//             show={showToastMessage}
//           />
//         )}
//     </Grid>
<Grid container boxShadow={4} borderRadius={4} p={2}>
  {/* اولین بخش کارت */}
  <Grid item xs={12}>
    <Box
      display="flex"
      width="100%"
      alignItems="start"
      minHeight="80px"
      justifyContent="space-between"
      sx={{
        flexDirection: { xs: "row", sm: "row" }, // چینش برای موبایل و دسکتاپ
        textAlign: { xs: "center", sm: "left" }
      }}
    >
      <Box display="flex" alignItems="center" sx={{ flexDirection: { xs: "row", sm: "row" } }}>
        <FlagIcon fontSize="large" />
        {name.length > 65 ? (
          <Tooltip sx={{ fontSize: "1.5rem !important" }} title={name}>
            <Typography
              mt={1}
              textAlign="left"
              variant="body1"
              sx={{
                fontSize: { xs: "10px", sm: "13px" },
                fontWeight: 600,
                color: "black",
                cursor: "pointer"
              }}
            >
              {name.slice(0, 65)}
            </Typography>
          </Tooltip>
        ) : (
          <Typography
            mt={1}
            textAlign="left"
            sx={{
              fontSize: { xs: "12px", sm: "13px" },
              fontWeight: 600,
              color: "black",
              cursor: "pointer"
            }}
          >
            {name}
          </Typography>
        )}
      </Box>
      <Box display="flex" justifyContent="end" alignItems="center" >
        <Tooltip title="ویرایش">
          <IconButton onClick={() => initialEditObject(id)}>
            <EditIcon color="primary" />
          </IconButton>
        </Tooltip>
        <Tooltip title="حذف">
          <IconButton onClick={handleClickOpen}>
            <DeleteIcon color="error" />
          </IconButton>
        </Tooltip>
        <Tooltip  title="کپی هدف به دوره زمانی بعدی ">
        <IconButton onClick={initialTransferShowDet} >
        <TransferIcon color='primary'   />
        </IconButton>
        </Tooltip>
        <Dialog
          fullScreen={fullScreen}
          open={open}
          onClose={handleClose}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle
            id="responsive-dialog-title"
            fontWeight={600}
            fontSize="17px"
          >
            {"آیا از حذف هدف اطمینان دارید؟"}
          </DialogTitle>
          <DialogActions>
            <Button autoFocus onClick={handleClose}>
              <Typography color="red">انصراف</Typography>
            </Button>
            <Button onClick={initialDeleteObject} autoFocus>
              <Typography color="#00387C">تایید</Typography>
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          fullScreen={fullScreen}
          open={open1}
          onClose={handleClose1}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle
            id="responsive-dialog-title"
            fontWeight={600}
            fontSize="17px"
          >
            {"آیا از کپی هدف مورد نظر اطمینان دارید؟"}
          </DialogTitle>
          <DialogActions>
            <Button autoFocus onClick={handleClose1}>
              <Typography color="red">انصراف</Typography>
            </Button>
            <Button onClick={initialDeleteObject1} autoFocus>
              <Typography color="#00387C">کپی</Typography>
            </Button>
            <Button onClick={initialDeleteObject2} autoFocus>
              <Typography color="green">کپی بهمراه نتایج کلیدی</Typography>
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    </Box>
  </Grid>

  {/* بخش اطلاعات مسئول */}
  {/* <Grid item xs={12}>
    <Box
      display="flex"
      alignItems="center"
      justifyContent="start"
      sx={{ mt: { xs: 1, sm: 2 } }}
    >
         <img src={
                  personPicture !== null && personPicture !== undefined &&
                  personPicture.filter((x:any)=>x.personId === responsibleId)[0] !== null &&
                  personPicture.filter((x:any)=>x.personId === responsibleId)[0]!== undefined
                  ?
                  personPicture.filter((x:any)=>x.personId === responsibleId)[0].pictureBase64String
                  :''
                } width={'25px'} style={{borderRadius:'50%'}} />
      <Typography px={1} variant="button" fontWeight={900} color="black">
        {responsibleName}
      </Typography>
    </Box>
  </Grid> */}
  <Grid item xs={12}>
  <Box
    display="flex"
    alignItems="center"
    justifyContent="start"
    sx={{ mt: { xs: 1, sm: 2 } }}
  >
    <Box
      width="40px" // عرض محدود باکس
      height="40px" // ارتفاع محدود باکس
      display="flex"
      alignItems="center"
      justifyContent="center"
      overflow="hidden" // جلوگیری از خروج تصویر از باکس
      borderRadius="50%" // گرد کردن باکس
    >
      <img
        src={
          personPicture !== null &&
          personPicture !== undefined &&
          personPicture.filter((x: any) => x.personId === responsibleId)[0] !==
            null &&
          personPicture.filter((x: any) => x.personId === responsibleId)[0] !==
            undefined
            ? personPicture.filter((x: any) => x.personId === responsibleId)[0]
                .pictureBase64String
            : ""
        }
        // alt="Responsible"
          style={{
            borderRadius: "50%",
            width: "40px", // عرض ثابت
            height: "40px", // ارتفاع ثابت
            objectFit: "contain", // نمایش کامل تصویر با تناسب
          }}
      />
    </Box>
    <Typography px={1} variant="button" fontWeight={900} color="black">
      {responsibleName}
    </Typography>
  </Box>
</Grid>


  {/* بخش دکمه لایک و کامنت */}
  <Grid item xs={12}>
    <Box
      display="flex"
      flexDirection="row-reverse"
      alignItems="center"
      justifyContent="space-between"
    >
      <Box display="flex" alignItems="center">
        <button className={`btnn ${activeBtn === "like" ? "like-active" : ""}`} onClick={() => handleReactionClick("like")}>
          <LikeIcon /> {likec}
        </button>
        <Box mr={2}>
          <CommentModal id={id} name={name} commentCount={commentCount} />
        </Box>
      </Box>
      <Box display="flex" alignItems="center">
        <CompanyManagmentIcon width="20px" height="20px" />
        {definitionLevelName.length > 45 ? (
          <Tooltip sx={{ fontSize: "0.75rem !important" }} title={definitionLevelName}>
            <Typography px={1} sx={{ color: "black", fontWeight: 900 }}>
              {definitionLevelName.slice(0, 45)}
            </Typography>
          </Tooltip>
        ) : (
          <Typography px={1} sx={{ color: "black", fontWeight: 900 }}>
            {definitionLevelName}
          </Typography>
        )}
      </Box>
    </Box>
  </Grid>

  {/* بخش ProgressBar */}
  <Grid item xs={12}>
    <Box width="100%">
      <DyLinearProgress value={evaluationPercentage} />
    </Box>
  </Grid>

  {/* بخش وضعیت و دکمه جزئیات */}
  <Grid item xs={12}>
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      textAlign="center"
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        bgcolor={objectivesStateName === "فعال" ? "#D5f7D4" : "#bfd3f5"}
        width="90px"
        height="28px"
        borderRadius={3}
      >
        <Typography
          color={objectivesStateName === "فعال" ? "green" : "#3a82fc"}
          fontSize={{
            xs: "10.5px",  // اندازه فونت برای موبایل
            sm:"0.8rem",    // اندازه فونت برای وب و صفحه‌های بزرگتر
          }}        >
          {objectivesStateName === "فعال" ? "فعال" : "پیش نویس"}
        </Typography>
      </Box>

      <Box display="flex" alignItems="center" justifyContent="center" bgcolor="#FBF0EA" width="95px" height="28px" borderRadius={3}>
        <Typography color="#F95700" 
             fontSize={{
              xs: "10.5px",  // اندازه فونت برای موبایل
              sm:"0.8rem",    // اندازه فونت برای وب و صفحه‌های بزرگتر
            }}        >
          {keyResultCount} نتیجه کلیدی
        </Typography>
      </Box>

      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        width="100px"
        borderRadius={3}
      >
        <Button variant="text" onClick={goObjectiveDetails}>
          <Typography
             fontSize={{
              xs: "10.5px",  // اندازه فونت برای موبایل
              sm:"0.8rem",    // اندازه فونت برای وب و صفحه‌های بزرگتر
            }}
           color="#0d0d0c">
            نمایش جزئیات
          </Typography>
        </Button>
      </Box>
    </Box>
  </Grid>
  {/* نمایش پیام Toast */}
  {showToastMessage && (
    <DYToastMessage
      isSuccess={isSucces}
      message={tMessage}
      setShow={setShowToastMessage}
      show={showToastMessage}
    />
  )}
</Grid>

  );
};

export default OCart;
